import script from "./MotelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MotelPage.vue?vue&type=script&setup=true&lang=js"

import "./MotelPage.vue?vue&type=style&index=0&id=0d98b6de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d98b6de"]])

export default __exports__